module.exports = __webpack_public_path__ + "img/林森路下游.01858544.jpg";